import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { startSpinToWin } from '../../action/SpinToWinAction';
import SpinButton from '../SpinButton/SpinButton';
import SpinHeader from '../SpinHeader';
import { PRIZES } from '../../constant/prizes';
import classes from './SpinIntro.module.css';

interface SpinIntroProps {
  onBeginTransition?: () => void;
}

const SpinIntro: FC<SpinIntroProps> = ({ onBeginTransition }) => {
  const dispatch = useDispatch();

  // Swap to How It Works straight away. Fading this page out first left a gap
  // where it had reached opacity 0 but the next step hadn't rendered yet, so
  // the screen went empty mid-transition.
  const handleBegin = () => {
    onBeginTransition?.();
    dispatch(startSpinToWin());
  };

  return (
    <div className={`${classes.root} spin-intro`}>
      <div className={classes.content}>
        <div className={classes.headerContainer}>
          <SpinHeader />
        </div>
        <h1 className={classes.title}>
          SPIN IT<br />TO WIN IT
        </h1>

        <p className={classes.subtitle}>
          BUILD THE RING | HIT THE TARGET PRICE | WIN
        </p>

        <SpinButton onClick={handleBegin} className="!mb-20 gsap-primary-btn-tap">
          Tap to Begin
        </SpinButton>

        <div className={classes.prizesSection}>
          <p className={classes.prizesHeading}>GRAND PRIZES</p>
          <div className={classes.prizesRow}>
            {PRIZES.map(({ rank, badge, image, label, featured }, index) => (
              <div key={rank} className={`${classes.prizeCard}${featured ? ` ${classes.prizeCardFeatured}` : ''}`}>
                <img src={badge} alt={rank} className={classes.prizeBadge} draggable={false} />
                <img src={image} alt={label} className={`${classes.prizeImage} ${index === PRIZES.length -1 ? "!scale-[1.3]" :""}`} draggable={false} />
                <p className={classes.prizeLabel}>{label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpinIntro;
